(function(){
if (window.__uf3init) return; window.__uf3init = 1;
var hasGsap = typeof gsap !== 'undefined';
if (hasGsap) document.documentElement.classList.add('js');

var marq = document.getElementById('marq');
if (marq) marq.innerHTML += marq.innerHTML;

var frames = document.querySelectorAll('#stage .frame');
var stepEls = Array.prototype.slice.call(document.querySelectorAll('#steps .s-step'));
var curFrame = 0;
function setFrame(i){
if (i === curFrame) return;
curFrame = i;
frames.forEach(function(f,j){ f.classList.toggle('active', i===j); });
}
function frameCheck(){
if (!frames.length || !stepEls.length) return;
var mid = window.innerHeight * 0.5, pick = -1;
for (var k = 0; k < stepEls.length; k++){
var r = stepEls[k].getBoundingClientRect();
if (r.top <= mid && r.bottom >= mid){ pick = k; break; }
if (r.top > mid){ pick = Math.max(0, k - 1); break; }
}
if (pick === -1) pick = stepEls.length - 1;
setFrame(pick);
}

var buybar = document.getElementById('uf3buybar');
var hero = document.querySelector('.uf3-hero');
function onScroll(){
frameCheck();
if (buybar){
var threshold = hero ? (hero.offsetTop + hero.offsetHeight) : window.innerHeight;
buybar.classList.toggle('on', window.scrollY > threshold && window.scrollY < document.body.scrollHeight - window.innerHeight * 2.2);
}
}
window.addEventListener('scroll', onScroll, {passive:true}); onScroll();

var rail = document.getElementById('rail');
if (rail){
document.querySelectorAll('.rail-btn').forEach(function(b){
b.addEventListener('click', function(){ rail.scrollBy({left: (parseInt(b.dataset.dir))*(rail.querySelector('.b-card').offsetWidth+20), behavior:'smooth'}); });
});
var isDown=false, startX, scrollLeft;
rail.addEventListener('mousedown', function(e){ isDown=true; startX=e.pageX; scrollLeft=rail.scrollLeft; rail.style.cursor='grabbing'; });
window.addEventListener('mouseup', function(){ isDown=false; rail.style.cursor='grab'; });
rail.addEventListener('mousemove', function(e){ if(!isDown) return; e.preventDefault(); rail.scrollLeft = scrollLeft - (e.pageX - startX)*1.4; });
var railbar = document.getElementById('railbar');
if (railbar){
rail.addEventListener('scroll', function(){
var p = rail.scrollLeft / (rail.scrollWidth - rail.clientWidth);
railbar.style.width = (20 + p*80) + '%';
}, {passive:true});
}
}

var slides = document.querySelectorAll('.q-slide');
var dotsWrap = document.getElementById('qdots');
if (slides.length && dotsWrap){
var qi = 0, qt;
var show = function(i){
qi = i;
slides.forEach(function(s,j){ s.classList.toggle('active', j===i); });
dotsWrap.querySelectorAll('.q-dot').forEach(function(d,j){ d.classList.toggle('active', j===i); });
};
var next = function(){ show((qi+1)%slides.length); };
var reset = function(){ clearInterval(qt); qt = setInterval(next, 5200); };
slides.forEach(function(_,i){
var d = document.createElement('button');
d.className = 'q-dot' + (i===0?' active':'');
d.addEventListener('click', function(){ show(i); reset(); });
dotsWrap.appendChild(d);
});
reset();
}

var facts = document.querySelectorAll('.fact');
function openFact(i){
facts.forEach(function(f){ f.classList.toggle('open', f.dataset.fact===String(i)); });
}
document.querySelectorAll('.hotspot').forEach(function(h){
h.addEventListener('click', function(){ openFact(h.dataset.fact); });
h.addEventListener('mouseenter', function(){ openFact(h.dataset.fact); });
});
facts.forEach(function(f){ f.addEventListener('click', function(){ openFact(f.dataset.fact); }); });

['grow1','grow2'].forEach(function(id){
var r = document.getElementById(id);
if (r && r.children.length) r.innerHTML += r.innerHTML;
});

if (!hasGsap) return;
gsap.registerPlugin(ScrollTrigger);

if (hero){
gsap.from('.uf3-hero .hl', {yPercent:110, duration:1.1, stagger:.12, ease:'power4.out', delay:.15});
gsap.to('#heroPh', {yPercent:12, ease:'none', scrollTrigger:{trigger:'.uf3-hero', start:'top top', end:'bottom top', scrub:true}});
}

document.querySelectorAll('.uf3 .rv').forEach(function(el){
gsap.fromTo(el, {opacity:0, y:24}, {
opacity:1, y:0, duration:.85, ease:'power2.out',
scrollTrigger:{trigger:el, start:'top 90%', once:true},
onComplete:function(){ el.classList.add('rv-done'); gsap.set(el, {clearProps:'all'}); }
});
});

document.querySelectorAll('[data-count]').forEach(function(el){
var end = parseFloat(el.dataset.count), pre = el.dataset.prefix||'', suf = el.dataset.suffix||'';
var dec = (''+end).indexOf('.') > -1 ? 1 : 0;
var obj = {v:0};
ScrollTrigger.create({
trigger: el, start:'top 85%', once:true,
onEnter: function(){
gsap.to(obj, {v:end, duration:1.6, ease:'power2.out', onUpdate:function(){
el.textContent = pre + obj.v.toFixed(dec) + suf;
}});
}
});
});

if (document.getElementById('intBig')){
gsap.to('#intBig', {xPercent:-28, ease:'none', scrollTrigger:{trigger:'.uf3-interlude', start:'top bottom', end:'bottom top', scrub:true}});
gsap.fromTo('#intPh', {yPercent:-10}, {yPercent:10, ease:'none', scrollTrigger:{trigger:'.uf3-interlude', start:'top bottom', end:'bottom top', scrub:true}});
}

if (document.getElementById('tlfill')){
gsap.to('#tlfill', {scaleX:.72, duration:1.8, ease:'power2.inOut', scrollTrigger:{trigger:'.uf3 .tl-track', start:'top 75%', once:true}});
gsap.from('.uf3 .tl-node', {opacity:0, y:24, duration:.8, stagger:.2, ease:'power2.out', scrollTrigger:{trigger:'.uf3 .tl-track', start:'top 75%', once:true}, clearProps:'all'});
}

document.querySelectorAll('.m-dot').forEach(function(d){
gsap.fromTo(d, {left:'6%'}, {left:d.dataset.to, duration:1.4, ease:'power3.out', scrollTrigger:{trigger:d, start:'top 90%', once:true}});
});

if (document.querySelector('.uf3 .stack-right')){
gsap.from('.uf3 .stack-row', {opacity:0, x:20, duration:.6, stagger:.07, ease:'power2.out', scrollTrigger:{trigger:'.uf3 .stack-right', start:'top 80%', once:true}, clearProps:'all'});
}

window.addEventListener('load', function(){ ScrollTrigger.refresh(); });
})();